import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';

import { Api } from '@providers/api/api';

@Injectable()
export class PresensiProvider {
  
    constructor(public api: Api) { }

    changeProductivity(params?:any){
        let seq = this.api.post('index.php/presensi/Attendance/changeProductivity', params);
        return seq;  
    }

    addCollectiveLeave(params?:any){
        let seq = this.api.post('index.php/presensi/Attendance/addCollectiveLeave', params);
        return seq; 
    }
}



// WEBPACK FOOTER //
// ./src/providers/myradiant/presensi/provider.ts